import { render, staticRenderFns } from "./GenericCrud.vue?vue&type=template&id=0fa43137&"
import script from "./GenericCrud.vue?vue&type=script&lang=js&"
export * from "./GenericCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports